import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../auth/auth.store';
import { CurrentUserService } from '../services';

const SUBSCRIPTION_EXPIRED_PATH = '/subscription-expired';

export const licenseGuard: CanActivateFn = async (_route, state) => {
  const authStore = inject(AuthStore);
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);

  if (state.url.startsWith(SUBSCRIPTION_EXPIRED_PATH)) {
    return true;
  }

  if (!authStore.isAuthenticated()) {
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url },
    });
  }

  const hasCurrentUser = await currentUserService.ensureCurrentUserLoaded();
  if (!hasCurrentUser) {
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url },
    });
  }

  return authStore.hasValidLicense()
    ? true
    : router.createUrlTree([SUBSCRIPTION_EXPIRED_PATH]);
};
